// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inputContainer[data-v-79f4e36a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  height: 48px;\n  border: 1px solid #d2d6dc;\n  border-radius: 0.125rem;\n  font-size: 14px;\n  padding-left: 0.75rem;\n}\n.inputClass[data-v-79f4e36a] {\n  outline: none;\n  margin-left: 5px;\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
